import { BlogPost } from '../types/blog-admin';

export function generateRssFeed(posts: BlogPost[], baseUrl: string): string {
  const latestPost = posts[0];
  const buildDate = latestPost
    ? new Date(latestPost.publishedAt!.toMillis()).toUTCString()
    : new Date().toUTCString();

  const items = posts
    .filter((post) => post.status === 'published' && post.publishedAt)
    .map((post) => {
      const pubDate = new Date(post.publishedAt!.toMillis()).toUTCString();
      const postUrl = `${baseUrl}/blog/${post.slug}`;
      const description = post.excerpt || post.seo.metaDescription;
      const imageUrl = post.featuredImage?.url || '';

      return `
    <item>
      <title>${escapeXml(post.title)}</title>
      <link>${escapeXml(postUrl)}</link>
      <guid isPermaLink="true">${escapeXml(postUrl)}</guid>
      <description><![CDATA[${description}]]></description>
      <pubDate>${pubDate}</pubDate>
      <author>noreply@getproductworkshop.com (${escapeXml(post.author)})</author>
      ${post.tags.map((tag) => `<category>${escapeXml(tag)}</category>`).join('\n      ')}
      ${imageUrl ? `<enclosure url="${escapeXml(imageUrl)}" type="image/jpeg" />` : ''}
      <content:encoded><![CDATA[
        ${imageUrl ? `<img src="${escapeXml(imageUrl)}" alt="${escapeXml(post.featuredImage?.alt || '')}" />` : ''}
        <p>${description}</p>
        <p><a href="${escapeXml(postUrl)}">Read more...</a></p>
      ]]></content:encoded>
    </item>`;
    })
    .join('');

  return `<?xml version="1.0" encoding="UTF-8"?>
<rss version="2.0"
     xmlns:content="http://purl.org/rss/1.0/modules/content/"
     xmlns:atom="http://www.w3.org/2005/Atom">
  <channel>
    <title>ProductWorkshop Blog</title>
    <link>${baseUrl}/blog</link>
    <description>Insights on product management, user feedback, and building products people love.</description>
    <language>en-us</language>
    <lastBuildDate>${buildDate}</lastBuildDate>
    <atom:link href="${baseUrl}/rss.xml" rel="self" type="application/rss+xml" />
    <image>
      <url>${baseUrl}/logo.png</url>
      <title>ProductWorkshop</title>
      <link>${baseUrl}/blog</link>
    </image>
${items}
  </channel>
</rss>`;
}

function escapeXml(unsafe: string): string {
  return unsafe.replace(/[<>&'"]/g, (c) => {
    switch (c) {
      case '<':
        return '&lt;';
      case '>':
        return '&gt;';
      case '&':
        return '&amp;';
      case "'":
        return '&apos;';
      case '"':
        return '&quot;';
      default:
        return c;
    }
  });
}
